// extracted by mini-css-extract-plugin
export default {"nsa_section_tab_page_parent":"NSASectionViewTabPage_nsa_section_tab_page_parent__vyVRL","nsa_section_tab_page_item":"NSASectionViewTabPage_nsa_section_tab_page_item__dKphV"};